﻿import api from '../api';
import { Item } from './ItemClausula';
import { TipoClausula } from './tipoClausula';

export interface Clausula {
  tipoClausulaDescricao: string;
  id: string;
  descricao: string;
  tipoClausula: TipoClausula;
  tipoClausulaId: string;
  itens: Item[];
  mostrarNumero: boolean;
}

export interface ClausulaPesquisa {
  termo: string;
  tipoClasulaId: string;
  clausulaMinutaId: string;
}

export interface Clausulas {
  clausulas?: Clausula[];
}

export const UpdateClausula = (values: any) => api.put<Clausula>('clausulas/putClausula', values);
export const UpdateManyClausula = (values: any) => api.put<Clausulas>('clausulas/UpdateManyClausulas', values);

export const UpdateStatusItemNivel1 = (values: any) => api.put<Clausula>('clausulas/updateStatusItemNivel1', values);

export const UpdateStatusItemNivel2 = (values: any) => api.put<Clausula>('clausulas/updateStatusItemNivel2', values);

export const ReprovarItemClausula = (values: any) => api.put<Clausula>('clausulas/reprovarItemClausula', values);

export const EnviarParaAprovacaoItemClausula = (values: any) =>
  api.put<Item>('clausulas/enviarParaAprovacaoItemClausula', values);

export const EnviarTodosParaAprovacaoItemClausula = (values: any) =>
  api.put('clausulas/enviarTodosParaAprovacaoItemClausula', values);

export const enviarTodosParaAprovacaoNivel1ou2 = (fluxo: any, id: string) =>
  api.put(`clausulas/aprovar/${id}&${fluxo}`);

export const getAllClausula = () => api.get<Clausula[]>('clausulas/GetAllClausula');

export const deleteClausula = (id: string) => api.delete(`clausulas/${id}`);

export const getAllClausulaOptions = () =>
  getAllClausula().then(Clausulas =>
    (Clausulas || []).map(t => ({
      text: t.tipoClausulaDescricao.replaceAll(/ [–-].*/g, '') + ' - ' + t.descricao,
      value: t.id.toString(),
    })),
  );

export const getAllClausulaComItem = () => api.get<Clausula[]>('clausulas/getAllClausulaComItem');
export const getAllClausulaComItemNivel1 = () => api.get<Clausula[]>('clausulas/getAllClausulaComItemNivel1');
export const getAllClausulaComItemNivel2 = () => api.get<Clausula[]>('clausulas/getAllClausulaComItemNivel2');

export const getClausulaComTipo = (id: string) => api.get<Clausula>(`clausulas/getById/${id}`);

export const getAllClausulaComItemAprovado = (values: ClausulaPesquisa) => {
  if (values == undefined)
    values = {
      termo: '',
      tipoClasulaId: '',
      clausulaMinutaId: '',
    } as ClausulaPesquisa;

  if (values && values.termo == undefined) values.termo = '';

  if (values && values.tipoClasulaId == undefined) values.tipoClasulaId = '';

  if (values && values.clausulaMinutaId == undefined) values.clausulaMinutaId = '';

  return api.get<Clausula[]>(
    `clausulas/getAllClausulaComItemAprovado/?termo=${values.termo}&tipoClasulaId=${values.tipoClasulaId}&clausulaMinutaId=${values.clausulaMinutaId}`,
  );
};

export const getAllClausulaComItemPendente = (values: ClausulaPesquisa) => {
  if (values == undefined)
    values = {
      termo: '',
      tipoClasulaId: '',
    } as ClausulaPesquisa;

  if (values && values.termo == undefined) values.termo = '';

  if (values && values.tipoClasulaId == undefined) values.tipoClasulaId = '';

  return api.get<Clausula[]>(
    `clausulas/getAllClausulaComItemPendente/?termo=${values.termo}&tipoClasulaId=${values.tipoClasulaId}`,
  );
};
